import React, { useEffect } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch, useParams } from "react-router-dom";
import { createMuiTheme, fade, ThemeProvider } from '@material-ui/core/styles';

// the hoc
import { withTranslation } from 'react-i18next';

import './common.scss'

import { useIdleTimer } from 'react-idle-timer'

// Pages
import {
    TermsConditions,
    SelectService,
    ParticularsApplicant,
    PersonalInfo,
    LocationDetail,
    VehicleDetail,
    DateTimeDetail,
    PermitDetail,
    ApplicationDetail,
    MakePayment,
    SubmitSuccess,
    EnquiryStatus,
    RetrieveInfo,
    Confirmation,
    Privacy,
    Tutorial,
    Faq,
    TimeOut,
    IASDirectLoginV2
} from './pages/_index'

const defaultTheme = createMuiTheme({
    breakpoints: {
        values: {
            lg: 1024
        }
    }
});

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#A74128',
            grey: '#ccc',
        },
        secondary: {
            main: '#6C757D',
        },
        tnc: {
            main: '#F8F9FA',
            secondary: '#E8E3CD'
        },
        iamSmart: {
            main: '#2B7366'
        },
        repeatInput: {
            main: '#f7f7f7',
            secondary: '#e5e5e5'
        },
        danger: {
            main: '#DC3545'
        }
    },
    overrides: {
        MuiButton: {
          root: {
            borderRadius: 0,
          },
        },
        MuiFormControl: {
            root: {
                [defaultTheme.breakpoints.down('md')]: {
                    width: '100%'
                }
            }
        },
        MuiInputLabel: {
            root: {
                // display: 'flex',
                color: '#333',
                marginBottom: '4px'
            },
            formControl: {
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
            },
            shrink: {
                transform: 'translate(0, 1.5px)'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#333',
                marginBottom: '4px'
            }
        },
        MuiFormControlLabel: {
            root: {
                alignItems: 'flex-start'
            }
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '12px',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
            },
            arrow: {
                color: 'rgba(0, 0, 0, 0.8)',
            },
            popper: {
                marginTop: '-16px'
            }
        },
        MuiSelect: {
            root: {
                width: '380px',
                height: '32px',
                marginTop: '4px',
                paddingLeft: '10px',
                border: '1px solid #ccc',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
                transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                '&:focus': {
                    boxShadow: `${fade('#A74128', 0.25)} 0 0 0 0.2rem`,
                    borderColor: '#A74128',
                },
                '&:after': {
                    display: 'none'
                },

                [defaultTheme.breakpoints.down('md')]: {
                    width: '100%',
                    lineHeight: '20px'
                }
            },
            selectMenu: {
                height: '32px'
            },
            icon: {
                top: 'calc(50% - 10px)',
                right: '4px'
            }
        },
        MuiInput: {
            formControl: {
                position: 'relative',

                'label + &': {
                    marginTop: '0'
                }
            },
            underline: {
                '&:before': {
                    display: 'none'
                },
                '&:after': {
                    display: 'none'
                }
            }
        },
        MuiRadio: {
            root: {
                padding: '0 8px 8px'
            }
        },
        MuiCheckbox: {
            root: {
                padding: '0 8px 8px'
            }
        }
    },
    spacing: 2,
    breakpoints: {
        values: {
            lg: 1024
        }
    }
})

const pathPrefix = process.env.REACT_APP_SUB_ROUTE;
// const pathPrefix = '/epas/index';
function App({t, i18n}) {
    
    useEffect(()=>{
        setTimeout(()=>{
            window.location.href = pathPrefix + '/timeout';
        }, 2700000)
    }, [])
    const supportedLanguages = ["en", "tc"];
    return (
        <>
            <ThemeProvider theme={theme}>
                <Router>
                    <Switch>
                        <Route exact path={`${pathPrefix}/selectService`} component={SelectService} />
                        <Route exact path={`${pathPrefix}/particularsApplicant`} component={ParticularsApplicant} />
                        <Route exact path={`${pathPrefix}/personalInfo`} component={PersonalInfo} />
                        <Route exact path={`${pathPrefix}/dateTimeDetail`} component={DateTimeDetail} />
                        <Route exact path={`${pathPrefix}/vehicleDetail`} component={VehicleDetail} />
                        <Route exact path={`${pathPrefix}/locationDetail`} component={LocationDetail} />
                        <Route exact path={`${pathPrefix}/permitDetail`} component={PermitDetail} />
                        <Route exact path={`${pathPrefix}/applicationDetail`} component={ApplicationDetail} />
                        <Route exact path={`${pathPrefix}/makePayment`} component={MakePayment} />
                        <Route exact path={`${pathPrefix}/submitSuccess`} component={SubmitSuccess} />
                        <Route exact path={`${pathPrefix}/enquiryStatus`} component={EnquiryStatus} />
                        <Route exact path={`${pathPrefix}/retrieveInfo`} component={RetrieveInfo} />
                        <Route exact path={`${pathPrefix}/confirmation`} component={Confirmation} />
                        <Route exact path={`${pathPrefix}/privacy`} component={Privacy} />
                        <Route exact path={`${pathPrefix}/tutorial`} component={Tutorial} />
                        <Route exact path={`${pathPrefix}/faq`} component={Faq} />
                        <Route exact path={`${pathPrefix}/timeout`} component={TimeOut} />
                        <Route exact path={`${pathPrefix}/`} component={TermsConditions} />
                        <Route exact path={`${pathPrefix}/IASDirectLoginV2/:lang`} component={IASDirectLoginV2} />
                        <Route
                            exact
                            path={`${pathPrefix}/:lang`}
                            render={props =>
                                supportedLanguages.includes(props.match.params.lang) ? (
                                <TermsConditions {...props} />
                                ) : (
                                <Redirect to={`${pathPrefix}/en`} />
                                )
                            }
                        />
                        {/* <Route component={Error} /> */}
                    </Switch>
                </Router>
            </ThemeProvider>
        </>
    );
}

export default withTranslation()(App);
